import { Component, ViewChild, Input, ElementRef, Renderer2, AfterViewInit, HostListener } from '@angular/core';
import { text } from 'd3';

@Component ({
    selector: 'app-spinner',
    templateUrl: 'spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})

export class SpinnerComponent {
  @Input() show = true;
  @Input() text?;
  @Input() floatLeft = true;
  @Input() floatRight = true;
}
